/* Waka — unico dueno del filtro Hombre / Mujer / Todo, mas navegacion suave y carro */
(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  var VALID={hombre:1,mujer:1,todo:1};
  var GEN='todo';
  try{ var s=localStorage.getItem('wakaGen'); if(s&&VALID[s])GEN=s }catch(e){}
  var q=new URLSearchParams(location.search).get('gen');
  if(q&&VALID[q])GEN=q;
  function save(){ try{localStorage.setItem('wakaGen',GEN)}catch(e){} }
  save();

  function apply(){
    /* 1. tarjetas de los rieles */
    $$('[data-gender-rail]').forEach(function(rail){
      var shown=0;
      $$('[data-gen]',rail).forEach(function(c){
        var g=(c.getAttribute('data-gen')||'').toLowerCase();
        var ok=(!g||g==='unisex'||GEN==='todo'||g===GEN);
        c.classList.toggle('gen-off',!ok);
        c.style.removeProperty('display');
        if(ok)shown++;
      });
      var head=rail.closest('[data-rail-wrap]')||rail.parentNode;
      var lab=head.querySelector('[data-count]');
      if(lab)lab.textContent='/ '+shown+' ref';
      rail.scrollLeft=0;
    });
    /* 2. estado de todos los selectores */
    $$('[data-gpick]').forEach(function(box){
      $$('button[data-gen]',box).forEach(function(b){
        b.classList.toggle('on',(b.getAttribute('data-gen')||'').toLowerCase()===GEN);
      });
    });
    /* 3. contadores de las cards de categoria */
    $$('[data-cat-men]').forEach(function(el){
      var m=parseInt(el.getAttribute('data-cat-men')||'0',10);
      var w=parseInt(el.getAttribute('data-cat-women')||'0',10);
      el.textContent=GEN==='hombre'?m:(GEN==='mujer'?w:m+w);
    });
    /* 4. imagen de las cards de categoria */
    $$('.coll-card .cc-img').forEach(function(box){
      var imgs=$$('[data-gimg]',box); if(!imgs.length)return;
      var pick=imgs.filter(function(i){return i.getAttribute('data-gimg')===GEN})[0]
            || imgs.filter(function(i){return i.getAttribute('data-gimg')==='todo'})[0] || imgs[0];
      imgs.forEach(function(i){
        i.classList.toggle('on',i===pick);
        if(i.classList.contains('ph'))i.classList.toggle('off',i!==pick);
      });
    });
    /* 5. destinos que dependen del genero */
    $$('[data-cat-all]').forEach(function(a){
      var url=a.getAttribute('data-cat-all');
      if(GEN==='hombre'&&a.getAttribute('data-cat-all-men'))url=a.getAttribute('data-cat-all-men');
      if(GEN==='mujer'&&a.getAttribute('data-cat-all-women'))url=a.getAttribute('data-cat-all-women');
      if(url)a.setAttribute('href',url);
    });
    $$('[data-gen-link]').forEach(function(a){
      var base=a.getAttribute('data-gen-link');
      a.setAttribute('href',base+(base.indexOf('?')>-1?'&':'?')+'gen='+GEN);
      var t=a.querySelector('[data-gen-text]');
      if(t)t.textContent=GEN==='todo'?'Ver todo':'Ver todo '+GEN;
    });
    $$('[data-gen-label]').forEach(function(el){
      el.textContent=GEN==='todo'?(el.getAttribute('data-label-all')||'hombre y mujer'):GEN;
    });
    if(window.WAKA_SYNC_ARROWS)window.WAKA_SYNC_ARROWS();
  }

  /* un solo escuchador para todos los selectores de la pagina */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-gpick] button[data-gen]');
    if(!b)return;
    e.preventDefault();
    var g=(b.getAttribute('data-gen')||'').toLowerCase();
    if(!VALID[g])return;
    GEN=g; save(); apply();
    var u=new URL(location.href);
    u.searchParams.set('gen',GEN);
    if(history.replaceState)history.replaceState(null,'',u.pathname+u.search+u.hash);
  },true);

  /* ---------- scroll suave ---------- */
  function headOffset(){
    var w=$('#shopify-section-header')||$('header.nav');
    return w?w.getBoundingClientRect().height+12:96;
  }
  function smoothTo(el){
    var y=el.getBoundingClientRect().top+window.pageYOffset-headOffset();
    window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
  }
  function entrance(){
    var id=(location.hash||'').slice(1); if(!id)return;
    if(!document.getElementById(decodeURIComponent(id)))return;
    window.scrollTo(0,0);
    setTimeout(function(){ var e=document.getElementById(decodeURIComponent(id)); if(e)smoothTo(e) },280);
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href]'); if(!a)return;
    if(a.target==='_blank'||e.metaKey||e.ctrlKey||e.shiftKey)return;
    var href=a.getAttribute('href')||'';
    if(href.indexOf('#')<0)return;
    var parts=href.split('#'), path=parts[0], hash=parts[1];
    if(!hash)return;
    var qs='', p=path;
    if(path.indexOf('?')>-1){ qs=path.slice(path.indexOf('?')+1); p=path.slice(0,path.indexOf('?')) }
    var onHome=(location.pathname==='/'||location.pathname==='');
    var here=(p==='')||(p==='/'&&onHome)||(p===location.pathname);
    var el=document.getElementById(hash);
    if(!here||!el)return;
    e.preventDefault();
    var g=new URLSearchParams(qs).get('gen');
    if(g&&VALID[g]){ GEN=g; save(); apply() }
    smoothTo(el);
    if(history.replaceState)history.replaceState(null,'',(qs?('?'+qs):location.search)+'#'+hash);
  });

  /* ---------- carro ---------- */
  function wireTools(){
    var R=window.WAKA_ROUTES||{};
    var cart=$('#wkCartBtn'), panel=$('#cartPanel'), scrim=$('#scrim');
    if(cart&&panel&&!cart.dataset.wired){
      cart.dataset.wired='1';
      cart.addEventListener('click',function(ev){
        ev.preventDefault();
        $$('.panel').forEach(function(p){p.classList.remove('on')});
        panel.classList.add('on');
        if(scrim)scrim.classList.add('on');
        document.body.style.overflow='hidden';
      });
    }
    if(R.cart){
      fetch(R.cart+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json()})
        .then(function(c){
          $$('[data-cart-count]').forEach(function(b){b.textContent=c.item_count});
          var n=$('#cartN'); if(n)n.textContent=c.item_count;
        }).catch(function(){});
    }
  }

  function boot(){ apply(); wireTools(); entrance(); setTimeout(apply,400); setTimeout(apply,1000) }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('load',function(){apply();wireTools()});
  window.addEventListener('hashchange',function(){
    var id=(location.hash||'').slice(1); if(!id)return;
    var el=document.getElementById(decodeURIComponent(id)); if(el)smoothTo(el);
  });
  document.addEventListener('shopify:section:load',boot);
  window.WAKA_GEN=function(g){ if(g&&VALID[g]){GEN=g;save();apply()} return GEN };
})();
